function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import dayjs from 'dayjs';
import { convertJsonToSelectFieldValue } from './generics-conversion-service';
export var convertTestimonialSearchRequest = function convertTestimonialSearchRequest(testimonialSearchRequest) {
  var pagination = testimonialSearchRequest.pagination;
  var testimonials = testimonialSearchRequest.results.map(function (testimonial) {
    return _objectSpread(_objectSpread({}, testimonial), {}, {
      createdOn: dayjs(testimonial.createdOn).format('MMMM DD, YYYY'),
      source: testimonial.source || 'aje'
    });
  });
  return {
    testimonials: testimonials,
    pagination: pagination
  };
};
export var convertJsonToFormData = function convertJsonToFormData(formData) {
  var testimonialFiles = [];
  if (formData.file) {
    testimonialFiles.push({
      bucket: formData.file.bucket,
      identity: formData.file.identity,
      name: formData.file.name,
      previewUrl: "/api/testimonials/image/".concat(formData.identity),
      remoteName: formData.file.remoteName,
      status: 'success'
    });
  }
  return {
    identity: formData.identity,
    published: convertJsonToSelectFieldValue(formData.published ? '1' : '0'),
    approved: convertJsonToSelectFieldValue(formData.approved ? '1' : '0'),
    testimonial: formData.text,
    testimonialFiles: testimonialFiles
  };
};
export var convertFormDataToTestimonialUpdateRequest = function convertFormDataToTestimonialUpdateRequest(formData) {
  var testimonialDetails = {
    text: formData.testimonial,
    published: formData.published.value === '1',
    approved: formData.approved.value === '1',
    identity: formData.identity
  };
  if (formData.testimonialFiles && formData.testimonialFiles.length > 0) {
    testimonialDetails.file = {
      identity: formData.testimonialFiles[0].identity
    };
  }
  return {
    testimonialDetails: testimonialDetails
  };
};
export var convertFormDataToTestimonialCreationRequest = function convertFormDataToTestimonialCreationRequest(formData) {
  var testimonialDetails = {
    text: formData.testimonial
  };
  if (formData.testimonialFiles && formData.testimonialFiles.length > 0) {
    testimonialDetails.file = {
      identity: formData.testimonialFiles[0].identity
    };
  }
  return {
    testimonialDetails: testimonialDetails
  };
};
export var convertFormDataToRubriqTestimonialCreationRequest = function convertFormDataToRubriqTestimonialCreationRequest(formData) {
  var testimonialDetails = {
    text: formData.testimonial,
    source: 'rubriq',
    displayName: formData.displayName || '',
    jobTitle: formData.jobTitle || '',
    fieldDiscipline: formData.fieldDiscipline || '',
    institution: formData.institution || '',
    outcome: formData.outcome || '',
    manuscriptType: formData.manuscriptType || '',
    linkedinOrcid: formData.linkedinOrcid || ''
  };
  if (formData.testimonialFiles && formData.testimonialFiles.length > 0) {
    testimonialDetails.file = {
      identity: formData.testimonialFiles[0].identity
    };
  }
  return {
    testimonialDetails: testimonialDetails
  };
};